import React, { useState, Fragment } from "react";
import { Modal, ModalBody, Button, ModalHeader } from "reactstrap";
import IngresoGeneralForm from "./IngresoGeneralForm";

const IngresoGeneralModal = ({
  create = false,
  proyectoCodeSelected,
  proyectoNameSelected,
  partners,
  estudiantesIngreso,
  admin = null, // Keep as 'admin' to match parent
  proyectoMoneda,
  resetState
}) => {
  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  const title = create 
    ? "Agregando Ingreso en General" 
    : "Editando Ingreso en General";

  const button = create ? (
    <Button
      color="primary"
      className="float-end"
      onClick={toggle}
      style={{ minWidth: "200px" }}
    >
      Agregar Ingreso en General
    </Button>
  ) : (
    <Button onClick={toggle}>
      Editar
    </Button>
  );

  return (
    <Fragment>
      {button}
      <Modal isOpen={modal} toggle={toggle} unmountOnClose>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <IngresoGeneralForm
            resetState={resetState}
            toggle={toggle}
            proyectoCode={proyectoCodeSelected}
            proyectoName={proyectoNameSelected}
            proyectoMoneda={proyectoMoneda}
            partners={partners}
            estudiantesIngreso={estudiantesIngreso}
            admin={admin} // Pass as 'admin' to match what form expects
          />
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default IngresoGeneralModal;